import { combineReducers } from 'redux';
import { decisionSelectionReducer } from './decisionSelection';
import { moreLikeThisReducer } from './moreLikeThis';
import { actionSidebarReducer } from './actionSidebar';
import { actionSidebarRemoveReducer } from './actionSidebarRemove';
import { highlightReducer } from './highlight';
import { actionSidebarSummaryReducer } from './actionSidebarSummary';

export const reducersRaw = {
  decision: combineReducers({
    decisionSelection: decisionSelectionReducer,
    moreLikeThis: moreLikeThisReducer,
    actionSidebar: actionSidebarReducer,
    actionSidebarRemove: actionSidebarRemoveReducer,
    actionSidebarSummary: actionSidebarSummaryReducer,
    highlight: highlightReducer,
  }),
};
